<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">{{data?.title}}</h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" [mat-dialog-close]="true">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>

<mat-dialog-content class="flex flex-col items-center justify-center h-[calc(100%-4rem)]">
  <div class="flex flex-1 h-full items-center justify-center">
    <ng-container *ngIf="data?.media.mediaFileStreamingLink; else noMedia">
      <img *ngIf="data.media.type === MediaTypeEnum.Image && data.media.mediaFileStreamingLink" [src]="data.media.mediaFileStreamingLink" />

      <video
        *ngIf="data.media.type === MediaTypeEnum.Video && data.media.mediaFileStreamingLink"
        [src]="data.media.mediaFileStreamingLink"
        class="flex h-full"
        controls></video>
    </ng-container>
  </div>
</mat-dialog-content>

<ng-template #noMedia>
  <flow-no-data [title]="'notifications.error.mediaFileCouldNotBeShown' | translate"></flow-no-data>
</ng-template>